import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class MaintenanceService {

    api_url = environment.url;
    constructor(private http: HttpClient) { }

    getData(){
        return this.http.get(`${this.api_url}maintenance_failure`)
    }
    createFailure(data: any){
        return this.http.post(`${this.api_url}maintenance_failure/add`, data)
    }
    getMaintenanceType(){
        return this.http.get(`${this.api_url}maintenance/type`)
    }
    addMaintenance(data: any, id: any){
        return this.http.post(`${this.api_url}maintenance-request/add/${id}`, data)
    }
    showMaintenance(id: any){
        return this.http.get(`${this.api_url}maintenance-request/show/${id}`)
    }
    updateMaintenance(data: any, id: any){
        return this.http.put(`${this.api_url}maintenance-request/update/${id}`, data)
    }
    addMaintenanceCoordinator(data: any){
        return this.http.post(`${this.api_url}maintenance-request/coordinator/add`, data)
    }
    getListMaintenance(data: any){
        return this.http.post(`${this.api_url}maintenance-request/list`, data)
    }
    getRepairs(){
        return this.http.get(`${this.api_url}repairs`)
    }
    createRepair(data: any){
        return this.http.post(`${this.api_url}repairs`, data)
    }
    getRepairCategories(){
        return this.http.get(`${this.api_url}repair-categories`)
    }
    createRepairCategory(data: any){
        return this.http.post(`${this.api_url}repair-categories`, data)
    }
    getMaterials(){
        return this.http.get(`${this.api_url}materials`)
    }
    getPaymentMethod(){
        return this.http.get(`${this.api_url}payment_method`)
    }
    addPaymentRequest(data: any){
        return this.http.post(`${this.api_url}payment-request/add`, data)
    }
    addPaymentRecord(data: any){
        return this.http.post(`${this.api_url}payment-record/add`, data)
    }
    getPaymentRecordsByMaintenanceRequest(id: any){
        return this.http.get(`${this.api_url}payment-record/maintenance-request/${id}`)
    }
    cancelMaintenance(id: any){
        return this.http.post(`${this.api_url}maintenance-request/${id}/cancel`, {})
    }
    getMaintenanceStatusAdministrative(){
        return this.http.get(`${this.api_url}status-maintenance/administrative`)
    }
    getMaintenanceStatusSupervisor(){
        return this.http.get(`${this.api_url}status-maintenance/supervisor`)
    }
    getMaintenanceStatus(){
        return this.http.get(`${this.api_url}status-maintenance`)
    }
    updateMaintenanceStatus(data: any){
        return this.http.put(`${this.api_url}maintenance-request/${data.maintenance_request_id}/status`, {
            maintenance_status_id: data.maintenance_status_id
        })
    }
    downloadPdfReport(){
        return this.http.get(`${this.api_url}maintenance-request/pdf-report`, {
            responseType: 'blob'
        })
    }
    downloadInvoice(id: number){
        return this.http.get(`${this.api_url}maintenance-request/invoice/${id}`, {
            responseType: 'blob'
        })
    }
    getMaintenanceStatusDirection(){
        return this.http.get(`${this.api_url}status-maintenance/direction`)
    }
    uploadPaymentInvoice(formData: FormData, id: any){
        return this.http.post(`${this.api_url}payment-invoice/upload/${id}`, formData)
    }
}
